import {
  GetCorpVideoHeroComponentDocument,
  GetCorpVideoHeroComponentQuery,
  GetCorpVideoHeroComponentQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';
import { getLocalesForGraphQL } from '../utils/helpers';

export async function getCorpVideoHeroComponent(id: string, locale: string) {
  return client.query<GetCorpVideoHeroComponentQuery, GetCorpVideoHeroComponentQueryVariables>({
    query: GetCorpVideoHeroComponentDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
